import React, { Component } from 'react'

import TextPage from '../block/TextPage'
import Oblast from '../block/Oblast'
import Faq from '../block/Faq'
import Kviz from '../block/Kviz'

class App extends Component {

  handleClose() {

  }

  render() {

    const data = this.props?.data

    return (
      <>
        <TextPage data={data} />
        <div className='container mt-[20px]'>
          <Kviz data={data} hideFn={this.handleClose} />
        </div>
        <Oblast data={data} />
        <Faq data={data} />
      </>
    )
  }
}

export default App